/**
 * COMPONENTE SIDEBAR
 * ==================
 * Sidebar que contiene los widgets de cotizaciones y clima
 */

import React from 'react';
import CotizacionesWidget from './CotizacionesWidget';
import WeatherWidget from './WeatherWidget';

const Sidebar = ({ cotizacionesData, weatherData }) => {
    return (
        <div className="space-y-6">
            <CotizacionesWidget cotizacionesData={cotizacionesData} />
            <WeatherWidget weatherData={weatherData} />
        </div>
    );
};

export default Sidebar;
